import Vue from "vue";
import _ from 'lodash';
import { isEmpty } from 'lodash';
Object.defineProperty(Vue.prototype, '_', { value: _ });


Vue.filter("mailBuilderToBackEnd", function (nrePageObject, chosen_mail_group, mail_group_category_keys, mail_template) {
  const terms = [
    'recipient',
    'demand_quantity1',
    'unit_estimation.total_mp_cost',
    'unit_estimation_additional_mp_cost',
    'demand_quantity2',
    'quote_items',
    'demand_quantity3',
    'unit_estimation_nre_amortization_cost'
  ];
  var terms_to_be_replaced = [];
  var terms_to_replacing = [];
  _.forEach(terms, function (value) {
    terms_to_be_replaced.push('<:' + value + '>');
    terms_to_replacing.push('[$' + value + '$]');
  });
  console.log("terms_to_be_replaced::");
  console.log(terms_to_be_replaced);
  console.log("terms_to_replacing");
  console.log(terms_to_replacing);


  var recipientBuilder = function (chosen_mail_group, mail_group_category_keys) {
    let result = '';
    _.forEach(mail_group_category_keys, function (value) {
      let recipient_single_group = '';
      let recipients_list = _.map(chosen_mail_group[value], 'member_name');
      console.log(recipients_list);
      if (recipients_list != null && recipients_list.length > 0) {
        recipient_single_group = recipients_list.join(",");
      }
      if (recipient_single_group != "") {
        result += recipient_single_group + ',';
      }
    });

    if (result[-1] == ',' && result[-1] == result[-2]) {
      result = result.slice(0, -1);
    }

    if (result != '') {
      var arr = result.split(',');
      result = arr.filter(function (value, index, self) {
        return self.indexOf(value) === index;
      }).join(', ');
    }
    return result;
  };
  var quoteTableBuilder = function (quote_items) {
    let result = '';
    if (isEmpty(quote_items) != true) {
      result += '<table style="width: 100%" > \
                <tr>\
                <th>Type</th>\
                <th>Oppty ID</th>\
                <th>FTIE ID</th>\
                <th>SKU ID</th>\
                <th>Customize Description</th>\
                <th>Qty</th>\
                <th>Selling Price</th>\
                </tr>\
            [:quote_item_tr]\
            </table>';
      let tr_list = '';
      _.forEach(quote_items, function (value) {
        console.log("quoteTableBuilder forEach get value")
        console.log(value);

        var tr_temp = "\
                <tr>\
                <td>[:quote_type]</td>\
                <td>[:sales_force_opty]</td>\
                <td>[:ftie_id]</td>\
                <td>[:sku_id]</td>\
                <td>[:customization_description]</td>\
                <td>[:qty]</td>\
                <td class='font-weight-bold'>[:selling_price]</td>\
                </tr>\
                ";
        tr_temp = tr_temp.replace('[:quote_type]', (_.get(value, 'quote_type', 'XXX')));
        tr_temp = tr_temp.replace('[:sales_force_opty]', (_.get(value, 'sales_force_opty', 'XXX')));
        tr_temp = tr_temp.replace('[:ftie_id]', (_.get(value, 'ftie_id', 'XXX')));
        tr_temp = tr_temp.replace('[:sku_id]', (_.get(value, 'sku_id', 'XXX')));
        tr_temp = tr_temp.replace('[:customization_description]', (_.get(value, 'customization_description', 'XXX')));
        tr_temp = tr_temp.replace('[:qty]', (_.get(value, 'qty', 'XXX')));
        tr_temp = tr_temp.replace('[:selling_price]', (_.get(value, 'selling_price', 'XXX')));

        tr_list += tr_temp;
      });

      result = result.replace('[:quote_item_tr]', tr_list);
      console.log("build quote items result::");
      console.log(result);
    }
    return result;
  };

  console.log("mailBuilder-isEmpty(nrePageObject)==");
  console.log(isEmpty(nrePageObject));
  let mail_build_result = '';
  if (nrePageObject != null && isEmpty(nrePageObject) != true && isEmpty(chosen_mail_group) != true && isEmpty(mail_template) != true && isEmpty(mail_group_category_keys) != true) {
    console.log("in the filter: mailBuilder!");
    console.log("mail_template input ==");
    console.log(mail_template);
    mail_build_result = mail_template;
    // --- step 1: build recipients ---
    let recipients = recipientBuilder(chosen_mail_group, mail_group_category_keys);
    console.log("step 1: build recipients:")
    console.log(recipients);
    mail_build_result = mail_build_result.replace(terms_to_be_replaced[0], (terms_to_replacing[0] + recipients + terms_to_replacing[0]));

    // --- step 2: build basic info ---
    //demand_quantity1     //qty 1 == qty 3 == unit_estimation_curr_stage.demand_quantity.mp_cost,
    let demandQty1 = (_.get(nrePageObject.unit_estimation_curr_stage.demand_quantity, 'mp_cost', 0)).toString(); //nrePageObject.unit_estimation_curr_stage.demand_quantity.mp_cost
    mail_build_result = mail_build_result.replace(terms_to_be_replaced[1], (terms_to_replacing[1] + demandQty1 + terms_to_replacing[1]));
    mail_build_result = mail_build_result.replace(terms_to_be_replaced[6], (terms_to_replacing[6] + demandQty1 + terms_to_replacing[6]));

    //unit_estimation.total_mp_cost -> unit_estimation_curr_stage.total_cost.mp_cost
    let total_mp_cost = (_.get(nrePageObject.unit_estimation_curr_stage.total_cost, 'mp_cost', 0)).toString();
    mail_build_result = mail_build_result.replace(terms_to_be_replaced[2], (terms_to_replacing[2] + total_mp_cost + terms_to_replacing[2]));


    //unit_estimation_additional_mp_cost -> [.unit_estimation_curr_stage.additional_material_cost.mp_cost +.unit_estimation_curr_stage.additional_mva_cost.mp_cost]
    let unit_estimation_additional_mp_cost = (_.get(nrePageObject.unit_estimation_curr_stage.additional_material_cost, 'mp_cost', 0) + _.get(nrePageObject.unit_estimation_curr_stage.additional_mva_cost, 'mp_cost', 0)).toString();
    mail_build_result = mail_build_result.replace(terms_to_be_replaced[3], (terms_to_replacing[3] + unit_estimation_additional_mp_cost + terms_to_replacing[3]));


    //'demand_quantity2', --> unit_estimation_curr_stage.nre_amortization.nre_amortization_quantity
    let demandQty2 = (_.get(nrePageObject.unit_estimation_curr_stage.nre_amortization, 'nre_amortization_quantity', 0)).toString();
    mail_build_result = mail_build_result.replace(terms_to_be_replaced[4], (terms_to_replacing[4] + demandQty2 + terms_to_replacing[4]));

    //unit_estimation_nre_amortization_cost -->  [:unit_estimation_curr_stage.nre_amortization.nre_amortization_cost]
    let unit_estimation_nre_amortization_cost = (_.get(nrePageObject.unit_estimation_curr_stage.nre_amortization, 'nre_amortization_cost', 0)).toString();
    mail_build_result = mail_build_result.replace(terms_to_be_replaced[7], (terms_to_replacing[7] + unit_estimation_nre_amortization_cost + terms_to_replacing[7]));

    // --- step 3: build quote items table ---
    let quote_table_content = quoteTableBuilder(nrePageObject.quote_items)//quote_items:Array
    mail_build_result = mail_build_result.replace(terms_to_be_replaced[5], (terms_to_replacing[5] + quote_table_content + terms_to_replacing[5]));

    // --- step 4: others and final check ---


    return mail_build_result;
  }
  else {
    return mail_build_result;
  }
});


Vue.filter("mailBuilderToShow", function (mail_template) {
  console.log("mailBuilderToShow")
  const terms = [
    'recipient',
    'demand_quantity1',
    'unit_estimation.total_mp_cost',
    'unit_estimation_additional_mp_cost',
    'demand_quantity2',
    'quote_items',
    'demand_quantity3',
    'unit_estimation_nre_amortization_cost'
  ];
  var terms_to_be_replaced = [];
  var terms_to_replacing = [];
  _.forEach(terms, function (value) {
    terms_to_be_replaced.push('<:' + value + '>');
    terms_to_replacing.push('[$' + value + '$]');
  });
  console.log("terms_to_be_replaced::");
  console.log(terms_to_be_replaced);
  console.log("terms_to_replacing");
  console.log(terms_to_replacing);


  console.log("mailBuilderToShow-isEmpty(mail_template)==");
  console.log(isEmpty(mail_template));


  if (isEmpty(mail_template) != true && mail_template!='') {
    let mail_build_result = mail_template;
    _.forEach(terms_to_replacing, function (value) {
      for (var i = 0; i < 2; i++) {
        mail_build_result = mail_build_result.replace(value, '');
      }

    });

    // --- step 1: build recipients ---

    // --- step 2: build basic info ---

    // --- step 3: build quote items table ---

    // --- step 4: others and final check ---


    return mail_build_result;
  }
  else {
    return '';
  }
});



// WEBPACK FOOTER //
// ./src/helpers/mail-builder.js